export default __webpack_public_path__ + "static/media/image_27.0f39c24c.png";